
export const VERSION = '5.7.2'; // Update this manually on each release


